import axios from '@/axios'
// import router from '@/router'
import { Notify, Loading, QSpinnerTail } from 'quasar'
export default {
  state: {
    company: {},
    regions: [],
    cities: [],
    last3Companys: [],
    haveCompany: true,
    topCompany: []
  },
  actions: {
    registerCompany ({ dispatch }, json) {
      Loading.show({ spinner: QSpinnerTail, spinnerSize: 80, spinnerColor: 'blue' })
      axios.post('/platform/company', {
        city: {
          id: json.city.id
        },
        description: json.description,
        email: json.email,
        imgsUrl: [],
        logoURL: json.logoURL,
        name: json.name,
        number: json.number,
        phone: json.phone,
        street: json.street,
        transportTypes: json.transportTypes,
        zipCode: json.zipCode
      })
        .then(res => {
          Notify.create({
            message: 'Sua empresa foi registrada com sucesso, ela ficará disponível no repositório após validação dos adminsitradores!',
            position: 'top',
            type: 'positive'
          })
          Loading.hide()
        })
        .catch(err => {
          console.log(err)
          Loading.hide()
        })
    },
    getCompany ({ commit }, companyId) {
      axios.get(`platform/company/${companyId}`)
        .then(res => {
          commit('setCompany', res.data)
        })
        .catch(err => {
          console.log(err)
        })
    },
    getInfoCompany ({ commit }) {
      axios.get('platform/company')
        .then(res => {
          commit('setCompany', res.data)
        })
        .catch(err => {
          if (err.response.data.message.indexOf('not found') !== -1) {
            commit('setHaveCompany')
          }
        })
    },
    getTopCompany ({ commit }) {
      axios.get('platform/company/search/top')
        .then(res => {
          commit('setTopCompany', res.data.content)
        })
        .catch(err => {
          console.log(err)
        })
    },
    getLast3Companys ({ commit }) {
      axios.get(`platform/company/lastCreated/3`)
        .then(res => {
          commit('setLast3Companys', res.data.content)
        })
        .catch(err => {
          console.log(err)
        })
    },
    putCompany ({ dispatch }, json) {
      let linkId
      if (json.linkId !== null) {
        linkId = json.linkId.toLowerCase()
      }
      Loading.show({ spinner: QSpinnerTail, spinnerSize: 80, spinnerColor: 'blue' })
      axios.put('/platform/company', {
        city: {
          id: json.city.id
        },
        description: json.description,
        email: json.email,
        id: json.id,
        imgsUrl: [],
        linkId: linkId,
        logoURL: json.logoURL,
        name: json.name,
        number: json.number,
        phone: json.phone,
        street: json.street,
        transportTypes: json.transportTypes,
        zipCode: json.zipCode
      })
        .then(res => {
          Notify.create({
            message: 'Informações alteradas com sucesso!',
            position: 'top',
            type: 'positive'
          })
          Loading.hide()
        })
        .catch(err => {
          console.log(err)
          Loading.hide()
        })
    },
    getCityList ({ commit }) {
      axios.get('/platform/address/regions')
        .then(res => {
          this.commit('setRegions', res.data)
        })
        .catch(err => {
          console.log(err)
        })
    },
    setRate ({ dispatch }, json) {
      axios.post(`/platform/company/rate/${json.id}?rate=${json.rate}`)
        .then(res => {
          console.log(res)
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  mutations: {
    setCompany (state, payload) {
      state.company = payload
    },
    setRegions (state, payload) {
      state.regions = payload
    },
    setLast3Companys (state, payload) {
      state.last3Companys = payload
    },
    setCompanyImg (state, payload) {
      state.company.logoURL = payload
    },
    setHaveCompany (state) {
      state.haveCompany = false
    },
    setTopCompany (state, data) {
      let cont = 0
      data.forEach(element => {
        element.index = cont
        cont++
      })
      state.topCompany = data
    }
  },
  getters: {
    getCompany: state => {
      return state.company
    },
    getCities: state => {
      return state.cities
    },
    getLast3Companys: state => {
      return state.last3Companys
    },
    getCompanyLogo: state => {
      return state.company.logoURL
    },
    getHaveCompany: state => {
      return state.haveCompany
    },
    getTopCompany: state => {
      return state.topCompany
    }
  }
}
